import { createRoot } from 'react-dom/client'
import { BrowserRouter, useNavigate } from 'react-router-dom'
import { ClerkProvider } from '@clerk/clerk-react'
import './index.css'
import App from './App'

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

function ClerkProviderWithRouter({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate()
  return (
    <ClerkProvider
      publishableKey={publishableKey}
      routerPush={(to: string) => {
        navigate(to)
        return Promise.resolve()
      }}
      routerReplace={(to: string) => {
        navigate(to, { replace: true })
        return Promise.resolve()
      }}
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  )
}

const root = document.getElementById('root')!

if (!publishableKey) {
  root.innerHTML = `
    <div style="padding: 2rem; font-family: sans-serif;">
      <h1>Configuration Error</h1>
      <p>Missing <code>VITE_CLERK_PUBLISHABLE_KEY</code> environment variable.</p>
      <p>Please check your <code>.env</code> file or Cloudflare Pages environment variables.</p>
    </div>
  `
} else {
  createRoot(root).render(
    <BrowserRouter>
      <ClerkProviderWithRouter>
        <App />
      </ClerkProviderWithRouter>
    </BrowserRouter>,
  )
}
